import { useEffect } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { BthLogo } from '../brand/BthLogo';
import { useAuth } from '../../contexts/AuthContext';

const NAV = [
  { segment: '', label: 'Calendar', end: true },
  { segment: 'tasks', label: 'Tasks', end: false },
] as const;

export function CalendarAppShell({ slug }: { slug: string }) {
  const { signOut } = useAuth();
  const base = `/calendar/${slug}`;

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.overflow;
    const prevBody = body.style.overflow;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prevHtml;
      body.style.overflow = prevBody;
    };
  }, []);

  return (
    <div className="cal-shell">
      <header className="cal-topbar">
        <div className="cal-topbar__brand">
          <BthLogo className="cal-topbar__logo" />
          <p className="cal-topbar__eyebrow">Personal calendar</p>
        </div>

        <nav className="cal-nav" aria-label="Calendar sections">
          {NAV.map((item) => (
            <NavLink
              key={item.label}
              to={item.segment ? `${base}/${item.segment}` : base}
              end={item.end}
              className={({ isActive }) => `cal-nav__link${isActive ? ' is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className="btn-secondary btn-sm cal-topbar__signout"
          onClick={() => void signOut()}
        >
          Sign out
        </button>
      </header>

      <main className="cal-main">
        <Outlet />
      </main>
    </div>
  );
}
